import {PROVIDER_FLAGS} from '@Constants/index.constants.js';

export const PreviewConsultationState = {
	url: '/consultation/:consultationId?showBack',
	title: 'Preview Consultation Comparison',
	params: {consultationId: null, showBack: null},
	// One state, one URL: the v2 provider flag decides which component renders. See
	// preview-proposal.route.js for the reasoning behind resolving the flag in lazyLoad.
	templateProvider: [
		'providerFlags',
		providerFlags =>
			providerFlags?.[PROVIDER_FLAGS.PRESENTATION_V2]
				? '<preview-consultation-v2></preview-consultation-v2>'
				: '<preview-consultation></preview-consultation>',
	],
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		const RoutesSvc = $transition$.injector().get('RoutesResolveSvc');
		return RoutesSvc.getPresentationFlags({trans: $transition$})
			.catch(() => ({}))
			.then(flags =>
				flags?.[PROVIDER_FLAGS.PRESENTATION_V2]
					? import(
							/* webpackChunkName: "previewConsultationV2Mod" */
							'@Containers/preview-consultation-page/preview-consultation-v2.cmp.js'
						)
					: import(
							/* webpackChunkName: "previewConsultationPageMod" */
							'@Containers/preview-consultation-page/preview-consultation.cmp.js'
						)
			)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
	resolve: [
		{
			token: 'canView',
			policy: {when: 'EAGER'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) =>
				RoutesSvc.validateConsultationPrivate({status: 'presented', ...trans.params()}).catch(state =>
					trans.router.stateService.go(state.name, state.params)
				),
		},
		{
			token: 'providerFlags',
			policy: {when: 'LAZY'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) => RoutesSvc.getPresentationFlags({trans}),
		},
	],
};
